import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import * as authService from '../services/authService';
import { EVENTO_SESION_EXPIRADA } from '../services/apiFetch';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(() =>
    authService.isAuthenticated() ? authService.getUsuario() : null
  );

  // apiFetch limpia la sesión ante un 401 y avisa por evento: así el estado de React se
  // entera y PrivateRoute redirige al login en vez de dejar la pantalla congelada.
  useEffect(() => {
    const onExpirada = () => setUsuario(null);
    window.addEventListener(EVENTO_SESION_EXPIRADA, onExpirada);
    return () => window.removeEventListener(EVENTO_SESION_EXPIRADA, onExpirada);
  }, []);

  const login = useCallback(async (email, password) => {
    const datos = await authService.login(email, password);
    setUsuario(datos);
    return datos;
  }, []);

  const logout = useCallback(() => {
    authService.logout();
    setUsuario(null);
  }, []);

  // Rol, institución y alcance vigentes en el servidor (un cambio de alcance aplica sin re-login).
  const refrescar = useCallback(async () => {
    try {
      const datos = await authService.refrescarSesion();
      if (datos) setUsuario(datos);
      return datos;
    } catch {
      return null;
    }
  }, []);

  const isAuthenticated = useCallback(() => authService.isAuthenticated(), []);

  return (
    <AuthContext.Provider value={{ usuario, login, logout, refrescar, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de <AuthProvider>');
  return ctx;
};

export default AuthContext;
